var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.998 1.042-.825-.848a.18.18 0 0 0-.132-.056.17.17 0 0 0-.13.056l-5.72 5.76-2.08-2.08a.19.19 0 0 0-.132-.057.19.19 0 0 0-.131.057l-.835.834a.187.187 0 0 0 0 .267L3.638 7.6c.169.169.375.267.549.267.248 0 .464-.183.543-.258h.005l6.267-6.3c.066-.08.066-.196-.004-.267"
  })));
};
export default SvgCheck;